import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[100]
  },
  sectionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  paymentBox: {
    marginTop: 30,
    border: `1px solid #DFE3E8`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  paymentRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1)
  },
  expiresTime: {
    color: theme.palette.error.main,
    fontWeight: 500
  },
  confirmButton: {
    width: '100%',
    color: theme.palette.common.white,
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,

    marginBottom: theme.spacing(1)
  },
  cancelButton: {
    width: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    color: theme.palette.text.secondary,
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    }
  },
  icon: {
    marginRight: 4,
    color: theme.palette.grey[800]
  }
}))

export default useStyles
